import React from 'react';
import classNames from 'classnames';
import { H3 } from '../Heading/Heading';

import css from './OptionCard.module.css';

function OptionCard({
  label,
  subtitle,
  selected,
  onClick,
  variant,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(css.root, {
        [css.selected]: selected,
        [css.large]: variant === 'large',
      })}
    >
      <H3 className={css.title}>{label}</H3>

      <p className={css.subtitle}>
        {subtitle}
      </p>
    </button>
  );
}

export default OptionCard;